export const commonBoardId = 'a0a0a0a0a0a0a0a0a0a0a0a0';

export const commonBoardColor = 'var(--glz-color-neutral-tone-4)';
